export interface WicketCheckoutResponse {
  id: string;
  type: string;
  url: string;
  state: string;
  embed: boolean;
  created_at: number;
  expires_at: number;
  object: string;
  updated_at: number;
  resource_version: number;
}
